<div class="pnl-settings-shipping-delivery">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Frete e entrega</h1>
  </header>

  <form [formGroup]="settingsFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="status">
        <strong>Serviço de delivery</strong>
        <span>
          Permite disponibilizar aos clientes um serviço de tele-entrega dos
          pedidos realizados na loja online
        </span>
        <div class="ipt-switch">
          <input
            [id]="status"
            formControlName="status"
            (change)="onChangeDetail()"
            name="status"
            type="checkbox"
            value="S"
          />
          <label [for]="status"></label>
        </div>

        <div *ngIf="status.value" class="ds_entrega">
          <label>Descrição</label>
          <input
            type="text"
            class="form-control"
            maxlength="200"
            formControlName="ds_entrega"
            (keyup)="onChangeDetail()"
          />
        </div>

        <div *ngIf="status.value" class="ds_entrega ds_raio_entrega">
          <label>Raio padrão do frete</label>
          <div class="sufx">
            <input
              type="text"
              class="form-control"
              formControlName="raio_entrega"
              currencyMask
              [options]="{ precision: 0, allowNegative: false }"
              (keyup)="onChangeDetail()"
            />
            <span class="distancia">km</span>
          </div>
        </div>
      </div>

      <div
        *ngIf="status.value"
        class="delivery-rules"
        [class.delivery-rules-pb]="select_delivery_type.value == '2'"
      >
        <strong>Regras do frete</strong>
        <div class="options">
          <mat-radio-group formControlName="select_delivery_type">
            <mat-radio-button name="select_delivery_type" value="1"
              >Frete 100% grátis, sem limite mínimo de compra</mat-radio-button
            >
            <mat-radio-button name="select_delivery_type" value="2"
              >Taxar o frete</mat-radio-button
            >
          </mat-radio-group>
        </div>

        <div *ngIf="select_delivery_type.value == '2'" class="value">
          <label>Valor padrão do frete</label>
          <div class="prefx">
            <span class="valor">R$</span>
            <input
              type="text"
              class="form-control"
              formControlName="preco"
              currencyMask
              (keyup)="onChangeDetail()"
            />
          </div>
        </div>

        <div
          *ngIf="select_delivery_type.value == '2'"
          class="free"
          [class.active]="ck_free.value"
        >
          <mat-checkbox formControlName="ck_free" class="example-margin"
            >Conceder frete grátis para pedidos com o valor do checkout a partir
            de</mat-checkbox
          >
          <div class="prefx">
            <span class="valor">R$</span
            ><input
              type="text"
              class="form-control"
              formControlName="gratis"
              currencyMask
              (keyup)="onChangeDetail()"
              [attr.disabled]="!ck_free.value ? '' : null"
            />
          </div>
        </div>
      </div>

      <div
        *ngIf="status.value && select_delivery_type.value == '2'"
        class="delivery-rules-options"
      >
        <strong>Regiões de entrega</strong>
        <span> Cadastre as faixas de CEP das regiões de entrega </span>
        <div class="range" formArrayName="entrega_faixa">
          <div
            *ngFor="let grp_faixa of entrega_faixa.controls; let i = index"
            [formGroupName]="i"
            [class.dnone]="grp_faixa.controls.valor.value == -1"
          >
            <div>
              <label>Inicio do CEP</label>
              <input
                type="text"
                class="form-control"
                formControlName="faixa_inicial"
                mask="00000-000"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div>
              <label>Fim do CEP</label>
              <input
                type="text"
                class="form-control"
                formControlName="faixa_final"
                mask="00000-000"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div>
              <label>Valor padrão do frete</label>
              <div class="prefx">
                <span class="valor">R$</span>
                <input
                  type="text"
                  class="form-control"
                  formControlName="valor"
                  currencyMask
                  (keyup)="onChangeDetail()"
                />
              </div>
            </div>
            <div>
              <mat-checkbox
                formControlName="ignora_distancia"
                class="ck-ignore"
                (change)="onChangeDetail()"
                >Ignora frete por distância</mat-checkbox
              >
            </div>
            <div>
              <mat-checkbox
                formControlName="dentro_raio"
                class="ck-ignore"
                (change)="onChangeDetail()"
                >Dentro do raio padrão</mat-checkbox
              >
            </div>
            <div class="actions">
              <a (click)="onRemoveCEP(i)" class="btn-close-round"></a>
            </div>
          </div>

          <button
            (click)="onAddNewCEP(undefined)"
            type="button"
            class="btn btn-green-outline"
          >
            <span>
              <i class="btn-add-round"></i> <span>Adicionar faixa de CEP</span>
            </span>
          </button>
        </div>
      </div>

      <div
        *ngIf="status.value && select_delivery_type.value == '2'"
        class="delivery-rules-options"
      >
        <strong>Frete por distâncias percorrida</strong>
        <span> Cadastre as taxas de frete pela distância </span>
        <div class="range range-distance" formArrayName="entrega_distancia">
          <div
            *ngFor="
              let grp_distancia of entrega_distancia.controls;
              let i = index
            "
            [formGroupName]="i"
          >
            <div>
              <label>Distancia até</label>
              <div class="sufx">
                <input
                  type="text"
                  class="form-control"
                  formControlName="distancia"
                  currencyMask
                  [options]="{ precision: 0, allowNegative: false }"
                  (keyup)="onChangeDetail()"
                />
                <span class="distancia">km</span>
              </div>
            </div>
            <div>
              <label>Valor do frete</label>
              <div class="prefx">
                <span class="valor">R$</span>
                <input
                  type="text"
                  class="form-control"
                  formControlName="valor"
                  currencyMask
                  (keyup)="onChangeDetail()"
                />
              </div>
            </div>
            <div class="actions">
              <a (click)="onRemoveDistance(i)" class="btn-close-round"></a>
            </div>
          </div>

          <button
            (click)="onAddNewDistance(undefined)"
            type="button"
            class="btn btn-green-outline"
          >
            <span>
              <i class="btn-add-round"></i> <span>Adicionar distância</span>
            </span>
          </button>
        </div>
      </div>

      <div
        *ngIf="status.value"
        class="delivery-rules-options delivery-rules-schedule"
      >
        <strong>Agendamento</strong>
        <span>Configure o funcionamento do agendamento:</span>

        <div class="form-col">
          <mat-checkbox
            formControlName="ck_delivery"
            (change)="onChangeDetail()"
            class="example-margin"
            >Ativar agendamento de entregas</mat-checkbox
          >
        </div>

        <div class="mt10" *ngIf="ck_delivery.value">
          <div class="form-col form-turnos">
            <label>Quantidade de entregas padrão por turno:</label>
            <div class="row">
              <div class="grid">
                <div class="row header">
                  <div class="col">
                    <label>Manhã</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="num_entrega_turno_manha"
                      currencyMask
                      [options]="{ precision: 0, allowNegative: false }"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                  <div class="col">
                    <label>Tarde</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="num_entrega_turno_tarde"
                      currencyMask
                      [options]="{ precision: 0, allowNegative: false }"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                  <div class="col">
                    <label>Noite</label>
                    <input
                      type="text"
                      class="form-control"
                      formControlName="num_entrega_turno_noite"
                      currencyMask
                      [options]="{ precision: 0, allowNegative: false }"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-col">
            <label>Margem padrão final em minutos:</label>
            <div class="row">
              <input
                type="text"
                class="form-control w180"
                formControlName="tempo_liberacao_delivery"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                (keyup)="onChangeDetail()"
              />
            </div>
          </div>

          <div class="form-col mt20">
            <label>Ajuste o inicio e fim dos turnos:</label>
            <div class="row mt10">
              <div class="grid">
                <div class="row header">
                  <div class="col">
                    <label>Final da manhã</label>
                    <input
                      type="text"
                      class="form-mat-input-element"
                      matInput
                      mask="Hh:m0"
                      [dropSpecialCharacters]="false"
                      placeholder="00:00"
                      formControlName="delivery_manha_fim"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                  <div class="col">
                    <label>Inicio da tarde</label>
                    <input
                      type="text"
                      class="form-mat-input-element"
                      matInput
                      mask="Hh:m0"
                      [dropSpecialCharacters]="false"
                      placeholder="00:00"
                      formControlName="delivery_tarde_inicio"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                  <div class="col">
                    <label>Final da tarde</label>
                    <input
                      type="text"
                      class="form-mat-input-element"
                      matInput
                      mask="Hh:m0"
                      [dropSpecialCharacters]="false"
                      placeholder="00:00"
                      formControlName="delivery_tarde_fim"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                  <div class="col">
                    <label>Inicio da noite</label>
                    <input
                      type="text"
                      class="form-mat-input-element"
                      matInput
                      mask="Hh:m0"
                      [dropSpecialCharacters]="false"
                      placeholder="00:00"
                      formControlName="delivery_noite_inicio"
                      (keyup)="onChangeDetail()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="status.value && ck_delivery.value"
        class="delivery-rules-options delivery-rules-schedule"
      >
        <strong>Grade de horários do agendamento</strong>
        <span>Configure a grade de horários de funcionamento:</span>

        <div class="grid" formArrayName="scheduling">
          <div class="row dnone-sm header mt10">
            <div class="col">
              <label>Dia da semana</label>
            </div>
            <div class="col">
              <label>Hora inicial</label>
            </div>
            <div class="col">
              <label>Hora final</label>
            </div>
            <div class="col">
              <label>Qtd de entregas</label>
            </div>
            <div class="col">
              <label>Margem final (em min)</label>
            </div>
            <div class="col actions"></div>
          </div>
          <div
            class="row row-scheduling"
            *ngFor="let grp_scheduling of scheduling.controls; let i = index"
            [formGroupName]="i"
            [class.dnone]="grp_scheduling.controls.diasemana.value == -1"
          >
            <div class="col">
              <label class="dflex-sm">Dia da semana</label>
              <ng-select
                [items]="dias_semana"
                (change)="onChangeDetail()"
                formControlName="diasemana"
                (clear)="onChangeDetail()"
                placeholder="Selecione"
                bindLabel="text"
                bindValue="value"
              ></ng-select>
            </div>
            <div class="col">
              <label class="dflex-sm">Hora inicial</label>
              <input
                type="text"
                class="form-mat-input-element"
                matInput
                mask="Hh:m0"
                [dropSpecialCharacters]="false"
                placeholder="00:00"
                formControlName="hora_inicio"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div class="col">
              <label class="dflex-sm">Hora final</label>
              <input
                type="text"
                class="form-mat-input-element"
                matInput
                mask="Hh:m0"
                [dropSpecialCharacters]="false"
                placeholder="00:00"
                formControlName="hora_fim"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div class="col">
              <label class="dflex-sm">Qtd de entregas</label>
              <input
                type="text"
                class="form-control"
                [attr.disabled]="onCheckValid(i)"
                formControlName="num_entregas"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div class="col">
              <label class="dflex-sm">Margem final (em min)</label>
              <input
                type="text"
                class="form-control"
                [attr.disabled]="onCheckValid(i)"
                formControlName="tempo_liberacao"
                currencyMask
                [options]="{ precision: 0, allowNegative: false }"
                (keyup)="onChangeDetail()"
              />
            </div>
            <div class="col actions">
              <a (click)="onRemoveRangeHour(i)" class="btn-close-round"></a>
            </div>
          </div>
          <div class="row">
            <button
              (click)="onAddNewRangeHour(undefined)"
              type="button"
              class="btn btn-green-outline"
            >
              <span>
                <i class="btn-add-round"></i> <span>Adicionar horário</span>
              </span>
            </button>
          </div>

          <div class="row mt10">
            <span
              >obs: A "Qtd de entregas", "Margem final (em min)" da grade só é
              utilizada quando existe mais de um intervalo para o mesmo dia da
              semana!</span
            >
          </div>
        </div>
      </div>

      <div
        *ngIf="status.value"
        class="delivery-rules-options delivery-rules-works"
      >
        <strong>Não funcionamento</strong>
        <span> Cadastre os dias que o serviço estará <b>indisponível</b> </span>

        <div class="range range-rules-works" formArrayName="holidays">
          <div
            *ngFor="let grp_holiday of holidays.controls; let i = index"
            [formGroupName]="i"
            [class.dnone]="grp_holiday.controls.tipo.value == -1"
          >
            <div>
              <label>Data</label>
              <div class="frm-datepicker">
                <input
                  type="text"
                  formControlName="dia"
                  class="form-control"
                  (dateInput)="onChangeDetail()"
                  [matDatepicker]="pickerInicialDate"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickerInicialDate"
                ></mat-datepicker-toggle>
                <mat-datepicker
                  #pickerInicialDate
                  [startAt]="startDate"
                ></mat-datepicker>
              </div>
            </div>
            <div>
              <label>Serviço</label>
              <ng-select
                [items]="formas_entrega"
                (change)="onChangeDetail()"
                (clear)="onChangeDetail()"
                formControlName="tipo"
                placeholder="Selecione"
                bindLabel="text"
                bindValue="value"
              ></ng-select>
            </div>
            <div class="actions">
              <a (click)="onRemoveHoliday(i)" class="btn-close-round"></a>
            </div>
          </div>

          <button
            (click)="onAddNewHoliday(undefined)"
            type="button"
            class="btn btn-green-outline"
          >
            <span>
              <i class="btn-add-round"></i> <span>Adicionar novo dia</span>
            </span>
          </button>
        </div>
      </div>
    </section>
  </form>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button
        type="button"
        (click)="onCancel()"
        class="btn btn-primary-outline"
      >
        Cancelar
      </button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">
        Salvar
      </button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
      <div class="ldio-ns36390yc">
        <div></div>
      </div>
    </div>
  </div>
</div>
